import { apiRequest } from './apiClient';

export async function getSchoolPeriods() {
  const response = await apiRequest('/student/school-periods');

  return response.data || [];
}

export async function getEducationalCalendar() {
  const response = await apiRequest('/student/calendar');

  return response.data || [];
}

export async function getWeeklySchedule() {
  const response = await apiRequest('/student/weekly-schedule');

  return response.data || [];
}
